import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-velda-articles-subnav',
    templateUrl: './velda-articles-subnav.component.html',
    styleUrls: ['./velda-articles-subnav.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class VeldaArticlesSubnavComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
